import React from 'react';
import { Card, styled } from '@mui/material';
import { Colors, LoadingSpinner } from 'library';

export function BasicCard({
    loading,
    small,
    children,
}: {
    loading: boolean;
    small: boolean;
    children: React.ReactNode;
}) {
    return (
        <StyledCard small={small.toString()}>
            {loading ? <LoadingSpinner loadingStyle={{ color: Colors.darkNavy }} /> : children}
        </StyledCard>
    );
}

const StyledCard = styled(Card)(({ small }: { small: string }) => ({
    borderRadius: 10,
    padding: 20,
    width: small === 'true' ? '100%' : '48%',
}));
